export enum EventKey {
  beforeunload = 'beforeunload',
  click = 'click',
  load = 'load',
  message = 'message',
  popout = 'popout',
  resize = 'resize',
  storage = 'storage',
  visibilityChange = 'visibilityChange',
}
